
let counter = 0;
const interval = setInterval(() => {
  const variantMap = BSS_B2B.storage?.variantStorage?.store;
  const prices = document.querySelectorAll('.compare-price-item');

  if (!variantMap || !variantMap.size || !prices.length) {
    counter += 100;
    if (counter >= 10000) clearInterval(interval);
    return;
  }

  // if(prices && BSS_B2B.shopData.template === "product" && !BSS_B2B.shopData?.customer?.tags?.includes('b2b')){
  //   const saleTags = document.querySelectorAll(".badge.price__badge-sale");
  //   if (!saleTags.length) return;
  //   saleTags.forEach((el, index) => {
  //     el.style.opacity = index === 0 ? "1" : "0";
  //   });
  // }

    const store = BSS_B2B?.storage?.productStorage?.store;
    const product = store?.values()?.next()?.value;


    if (product.bssB2bShowPriceKey === undefined || product.bssB2bShowPriceKey !== "cp") {
      document.querySelector('.variant-item__old-price').style.display = "none";
    }

  

  variantMap.forEach((variant) => {
    if (!variant?.compare_at_price) return;
    if (!variant?.appliedCP) return;

    const cp = variant.appliedCP;

    const baseComparePrice = Number(variant.compare_at_price);
    const discountType = Number(cp.discount_type);
    const discountValue = Number(cp.discount_value);
    const badgeValue = 0;

    let finalComparePrice = baseComparePrice;

    switch (discountType) {
      case 0: 
        finalComparePrice = baseComparePrice;
        break;

      case 2: 
        finalComparePrice =
          baseComparePrice - (baseComparePrice * discountValue) / 100;
        break;

      case 1: 
        finalComparePrice =
          baseComparePrice - discountValue;
        break;
    }

    finalComparePrice = Math.max(finalComparePrice, 0);


    const data = document
    .querySelectorAll(
      `.compare-price-item[bss-data-variant-id="${variant.id}"]`
    )
    .forEach((el) => {
      el.innerHTML = BSS_B2B.formatMoney(finalComparePrice);
    });
    // const badge = document.querySelector(".bss-badge");
    // badge.style.display = "block"
  }
);

  clearInterval(interval);
}, 100);



let counterPrice = 0;

const intervalPrice = setInterval(() => {
  const priceContainer = document.querySelector("[bss-b2b-product-price]");

  if (window.location.pathname.includes("/product") && window.BSS_B2B && priceContainer) {

    setTimeout(() => {
    const firstSpan = priceContainer.querySelector("span");
    if (firstSpan) {
        firstSpan.classList.add("bss-custom");
    } 
    },2000)

    clearInterval(intervalPrice);
  } else {
    counterPrice += 100;
    if (counterPrice >= 10000) {
      clearInterval(intervalPrice);
    }
  }
}, 100);

